import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { NavVariant } from './types';

function isNavVariant(value: string | null): value is NavVariant {
  return value === 'hybrid' || value === 'off';
}

export function useNavVariant(): NavVariant {
  const [searchParams] = useSearchParams();
  const rawFromHook = searchParams.get('nav');
  const rawFromWindow = useMemo(() => new URLSearchParams(window.location.search).get('nav'), []);
  const raw = rawFromHook ?? rawFromWindow;
  return useMemo<NavVariant>(() => (raw === 'off' ? 'off' : 'hybrid'), [raw]);
}

